import { render, staticRenderFns } from "./TaskModal.vue?vue&type=template&id=d18b9ffa&scoped=true&"
import script from "./TaskModal.vue?vue&type=script&lang=ts&"
export * from "./TaskModal.vue?vue&type=script&lang=ts&"
import style0 from "./TaskModal.vue?vue&type=style&index=0&id=d18b9ffa&lang=scss&scoped=true&"
import style1 from "./TaskModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18b9ffa",
  null
  
)

export default component.exports